import { appUrl } from '@astro/config'
import AboutOverviewPortrait from './AboutOverviewPortrait'
import { FEATURES } from './aboutOverviewData'

const STAR_PATH =
  'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z'

function FeatureItem({ feature }) {
  return (
    <li
      className="flex items-start gap-3.75 text-left transition-[box-shadow,border-color] duration-300"
      style={{
        padding: '16px 18px',
        borderRadius: '16px',
        background: 'rgba(255,255,255,.85)',
        border: '1px solid rgba(180,83,9,.12)',
        boxShadow: '0 2px 12px rgba(180,83,9,.05)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 6px 24px rgba(180,83,9,.10)'
        e.currentTarget.style.borderColor = 'rgba(180,83,9,.28)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 2px 12px rgba(180,83,9,.05)'
        e.currentTarget.style.borderColor = 'rgba(180,83,9,.12)'
      }}
    >
      <span
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '12px',
          background: 'linear-gradient(135deg,rgba(245,158,11,.18),rgba(180,83,9,.08))',
          border: '1px solid rgba(180,83,9,.18)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d={feature.path} />
          {feature.extraPaths?.map((d) => (
            <path key={d} d={d} />
          ))}
        </svg>
      </span>
      <div>
        <p style={{ fontFamily: 'var(--font-heading),serif', fontSize: '13px', fontWeight: 600, color: '#1C0A04', letterSpacing: '.04em', marginBottom: '3px' }}>
          {feature.title}
        </p>
        <p style={{ fontSize: '12.5px', lineHeight: 1.65, color: 'rgba(92,58,30,.65)', fontWeight: 400 }}>{feature.desc}</p>
      </div>
    </li>
  )
}

export default function AboutOverviewSection() {
  return (
    <section id="about-overview" className="relative py-20 lg:py-28 overflow-hidden" style={{ background: '#FDFAF5' }}>
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div style={{ position: 'absolute', top: '-80px', left: '-60px', width: 'min(520px,55vw)', height: 'min(520px,55vw)', borderRadius: '50%', background: 'radial-gradient(circle,rgba(245,158,11,.09) 0%,transparent 70%)', filter: 'blur(70px)' }} />
        <div style={{ position: 'absolute', bottom: '-80px', right: '-60px', width: 'min(480px,50vw)', height: 'min(480px,50vw)', borderRadius: '50%', background: 'radial-gradient(circle,rgba(180,83,9,.07) 0%,transparent 65%)', filter: 'blur(80px)' }} />
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg,transparent,rgba(180,83,9,.16),transparent)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg,transparent,rgba(180,83,9,.10),transparent)' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(rgba(180,83,9,0.055) 1px,transparent 1px)', backgroundSize: '34px 34px' }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '52px' }}>
          <div style={{ width: '40px', height: '1px', background: 'rgba(180,83,9,.45)' }} />
          {/* <span style={{ fontSize: '17px', lineHeight: 1, color: 'rgba(180,83,9,.80)' }}>ॐ</span> */}
          <span style={{ fontSize: '8.5px', fontWeight: 700, letterSpacing: '.40em', textTransform: 'uppercase', color: 'rgba(120,53,15,.65)' }}> About Astrologer Raju Maharaj Ji</span>
          {/* <span style={{ fontSize: '17px', lineHeight: 1, color: 'rgba(180,83,9,.80)' }}>ॐ</span> */}
          <div style={{ width: '40px', height: '1px', background: 'rgba(180,83,9,.45)' }} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="flex flex-col gap-5.5 text-center lg:text-left items-center lg:items-start">
            <h2
              className="uppercase"
              style={{ fontFamily: 'var(--font-heading),serif', fontSize: 'clamp(34px,5vw,45px)', fontWeight: 400, color: '#1C0A04', lineHeight: 1.06, letterSpacing: '-0.02em' }}
            >
              Trusted Guidance for <br className="hidden sm:block" />
              <span style={{ background: 'linear-gradient(96deg,#D97706,#F59E0B 45%,#D97706)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                Every Part of Life
              </span>
            </h2>

            <p style={{ fontSize: '14.5px', lineHeight: 1.85, color: 'rgba(92,58,30,.78)', fontWeight: 400, maxWidth: '480px' }}>
              Astrologer Raju Maharaj Ji is a respected Vedic astrologer with over 15+ years of experience. From
              honest Kundli readings to classes and sacred products, we help you find clarity, confidence and
              direction in everyday life.
            </p>

            <div className="flex items-center gap-2.5 flex-wrap justify-center lg:justify-start">
              <div style={{ display: 'flex', gap: '2px' }}>
                {Array.from({ length: 5 }, (_, i) => (
                  <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#F59E0B" stroke="none">
                    <path d={STAR_PATH} />
                  </svg>
                ))}
              </div>
              <div style={{ width: '1px', height: '12px', background: 'rgba(180,83,9,.20)' }} />
              <span style={{ fontSize: '9.5px', textTransform: 'uppercase', letterSpacing: '.22em', color: 'rgba(92,58,30,.55)' }}>
                5.0 · 10k+ happy people guided
              </span>
            </div>

            <ul className="flex flex-col gap-3.5 w-full text-left list-none p-0 m-0" style={{ maxWidth: '480px' }}>
              {FEATURES.map((feature) => (
                <FeatureItem feature={feature} key={feature.title} />
              ))}
            </ul>

            <div className="flex flex-wrap gap-3 items-center justify-center lg:justify-start">
              <a
                href="/about"
                className="inline-flex items-center gap-2.5 no-underline"
                style={{
                  padding: '0 30px',
                  height: '48px',
                  borderRadius: '999px',
                  background: 'linear-gradient(100deg,#D97706,#F59E0B,#D97706)',
                  backgroundSize: '200% 100%',
                  color: '#fff',
                  fontFamily: 'var(--font-heading),serif',
                  fontSize: '10px',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '.28em',
                  boxShadow: '0 8px 28px -6px rgba(217,119,6,.50),0 0 0 1px rgba(245,158,11,.22)',
                  transition: 'all .28s cubic-bezier(.22,1,.36,1)',
                  textShadow: '0 1px 2px rgba(60,16,8,.35)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.04)'
                  e.currentTarget.style.boxShadow = '0 12px 36px -4px rgba(217,119,6,.65),0 0 0 1px rgba(245,158,11,.36)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)'
                  e.currentTarget.style.boxShadow = '0 8px 28px -6px rgba(217,119,6,.50),0 0 0 1px rgba(245,158,11,.22)'
                }}
              >
                Read Our Story
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </a>
              <a
                href={appUrl("jyotish", "maharaj-ji")}
                className="inline-flex items-center gap-2 no-underline"
                style={{
                  padding: '0 26px',
                  height: '48px',
                  borderRadius: '999px',
                  background: 'transparent',
                  color: '#B45309',
                  fontFamily: 'var(--font-heading),serif',
                  fontSize: '10px',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '.26em',
                  border: '1.5px solid rgba(180,83,9,.35)',
                  transition: 'all .26s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(180,83,9,.06)'
                  e.currentTarget.style.borderColor = 'rgba(180,83,9,.65)'
                  e.currentTarget.style.color = '#92400E'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent'
                  e.currentTarget.style.borderColor = 'rgba(180,83,9,.35)'
                  e.currentTarget.style.color = '#B45309'
                }}
              >
                Meet the Maharaj Ji
              </a>
            </div>
          </div>

          <AboutOverviewPortrait />
        </div>
      </div>
    </section>
  )
}
